import type { AxiosRequestConfig } from 'axios'
import type { RequestOptions } from '@mp/http-axios'

import { createAxios } from './index'

// #region mch trade data request start
export const defHttp = createAxios({
  requestOptions: {
    // 接口地址
    apiUrl: window.location.origin,
    // 接口拼接地址
    urlPrefix: '/mchgateway/sdpmerchant',
  },
})

export function request<T>(url: string, options: AxiosRequestConfig & { customOptions?: RequestOptions }): Promise<T> {
  // @ts-ignore
  if (options?.params?.isForward) {
    // @ts-ignore
    defHttp.options.requestOptions.apiUrl = options?.params?.isForward ? `${(import.meta as any).env.VITE_WISP_URL}/forward-bff` : window.location.origin
    // @ts-ignore
    delete options?.params?.isForward
  }

  const { customOptions } = options || { }
  return defHttp.request({ ...options, url }, customOptions)
}
// #endregion mch trade data request end
